<template>
  <div class="starschermen">
    <subNav :doel="doel"></subNav>

    <div class="introtext">
      <h2 class="introtext__title">
        Er zijn {{ count }} methodes voor uw situatie
      </h2>
      <div v-html="schermtekst" class="introtext__content"></div>
    </div>

    <div class="questiongroup">
      <button class="button button--wide" @click="onStep2Clicked">
        Stap 2: Methodes
      </button>
    </div>
  </div>
</template>

<script>
import subNav from "../components/subNav.vue";
import storage from "../mixins/storage";

const ENDPOINT_NAME = "ppw/v1/tussenstap1";
const axios = require("axios");

export default {
  name: "uwSituatieEindscherm",

  mixins: [storage],

  data() {
    return {
      isLoading: true,
      isEmptyResult: false,
      methodes: [],
      scherm: "",
      schermtitel: "",
      schermtekst: "",
      initiatief: "",
      fase: "",
      count: 0,
      doel: "",
      slug: "",
      index: 0,
      pushers: [],
    };
  },

  components: {
    subNav,
  },

  computed: {},

  methods: {
    getMethodeCards() {
      // for which doel (taxonomy)?
      const doelSlug = this.$route.params.doelSlug;
      const url = new URL(
        process.env.VUE_APP_REST_URL + ENDPOINT_NAME + "?doelSlug=" + doelSlug
      );
      this.isLoading = true;
      this.isEmptyResult = false;

      // fetch(url)
      axios
        .get(url)
        .then((r) => {
          const results = r.data;
          if (!results) {
            this.methodes = [];
            this.isEmptyResult = true;
          } else {
            this.scherm = r.data.scherm;
            this.schermtekst = r.data.schermtekst;
            this.doel = r.data.doel;
            this.index = r.data.index;
            this.methodes = r.data.methodes;
            this.count = parseInt(r.data.count);
          }
        })
        .catch((error) => {
          console.warn(error);
        });
    },
    onStep2Clicked() {
      _paq.push(["trackEvent", "userEvent", "methodStarted"]);
      _paq.push(["trackEvent", "situation", this.getSituationAsString()]);
      this.$router.push({ name: 'methodes', params: { doelSlug: this.slug }, });
    },
  },

  created() {
    this.slug = this.$route.params.doelSlug;
    localStorage.setItem("slug", this.slug);
    setTimeout(() => this.getMethodeCards(), 50);
  },

  mounted() {},
};
</script>

